var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobileFitting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 12V4.65C12 3.80992 12 3.38988 11.8365 3.06901C11.6927 2.78677 11.4632 2.5573 11.181 2.41349C10.8601 2.25 10.4401 2.25 9.6 2.25H3.9C3.05992 2.25 2.63988 2.25 2.31901 2.41349C2.03677 2.5573 1.8073 2.78677 1.66349 3.06901C1.5 3.38988 1.5 3.80992 1.5 4.65V9.6C1.5 10.4401 1.5 10.8601 1.66349 11.181C1.8073 11.4632 2.03677 11.6927 2.31901 11.8365C2.63988 12 3.05992 12 3.9 12H12ZM12 12H15.3C15.72 12 15.9301 12 16.0905 11.9183C16.2316 11.8463 16.3463 11.7316 16.4183 11.5905C16.5 11.4301 16.5 11.22 16.5 10.8V8.74706C16.5 8.56361 16.5 8.47189 16.4793 8.38558C16.4609 8.30905 16.4306 8.23589 16.3895 8.16879C16.3431 8.0931 16.2782 8.02824 16.1485 7.89853L14.6015 6.35147C14.4718 6.22176 14.4069 6.1569 14.3312 6.11052C14.2641 6.0694 14.191 6.03909 14.1144 6.02072C14.0281 6 13.9364 6 13.7529 6H12M6.75 13.875C6.75 14.9105 5.91053 15.75 4.875 15.75C3.83947 15.75 3 14.9105 3 13.875C3 12.8395 3.83947 12 4.875 12C5.91053 12 6.75 12.8395 6.75 13.875ZM15 13.875C15 14.9105 14.1605 15.75 13.125 15.75C12.0895 15.75 11.25 14.9105 11.25 13.875C11.25 12.8395 12.0895 12 13.125 12C14.1605 12 15 12.8395 15 13.875Z",
    stroke: "#B78921",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileFitting);
export default __webpack_public_path__ + "static/media/icon-mobile-fitting.f2c64eac1fc9cc9d5b5784274e0c88f6.svg";
export { ForwardRef as ReactComponent };